import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const DateBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.60156 1.6001C4.93293 1.6001 5.20156 1.86873 5.20156 2.2001V3.2001H10.8016V2.2001C10.8016 1.86873 11.0702 1.6001 11.4016 1.6001C11.7329 1.6001 12.0016 1.86873 12.0016 2.2001V3.2001H12.2016C13.4166 3.2001 14.4016 4.18507 14.4016 5.4001V12.2001C14.4016 13.4151 13.4166 14.4001 12.2016 14.4001H3.80156C2.58654 14.4001 1.60156 13.4151 1.60156 12.2001V5.4001C1.60156 4.18507 2.58654 3.2001 3.80156 3.2001H4.00156V2.2001C4.00156 1.86873 4.27019 1.6001 4.60156 1.6001ZM3.80156 6.0001C3.24928 6.0001 2.80156 6.44781 2.80156 7.0001V12.2001C2.80156 12.7524 3.24928 13.2001 3.80156 13.2001H12.2016C12.7538 13.2001 13.2016 12.7524 13.2016 12.2001V7.0001C13.2016 6.44781 12.7538 6.0001 12.2016 6.0001H3.80156Z"
      fill="currentColor"
    />
  </IconContainer>
);
